<template>
  <svg
    class="icon-list-add"
    focusable="false"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
  >
    <path
      d="M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
    ></path>
  </svg>
</template>
<script>
export default {
  name: "IconListAdd"
};
</script>
<style lang="scss">
.icon-list-add {
  width: 21px;
  color: $white;
  filter: invert(1);
}
</style>